<template>
  <v-container>
    <v-container>
      <v-row v-if="items && items.length > 0">
        <v-col cols="3" v-for="(item, index) in items" v-bind:key="index">
          <v-card eight="100" @click="_detail(item, index)">
            <v-card-text>
              <h4>{{ item.name }}</h4>
            </v-card-text>
            <v-card-actions>
              <v-spacer> </v-spacer>
              <v-btn
                color="secondary"
                small
                class="mr-2 ml-4"
                @click.stop="_detail(item, index)"
                :ripple="false"
                elevation="0"
              >
                Xэвлэx
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div class="py-10" />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  name: "RegularTablesView",
  data: () => ({
    detailDialog: false,
    newDialog: false,
    deleteDialog: false,
    editedItem: {
      name: "",
      description: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
      description: "",
    },
    items: [],
    messageNotification: null,
    bulkText: null,
  }),
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this._read();
  },

  methods: {
 
    _detail(item, index) {
      this.editedItem = item;
      this.detailDialog = true;
      //"schools/YJHjHWUGDok8teDhDIKX/students/gEJAoZMiAVD1lzqCyTLL"
      //this.userProfile.ref.path
      console.log(item.ref.path)
      fb.db.doc(this.userProfile.ref.path).get().then(doc=>{
        let student = doc.data()
        student.ref = doc.ref
        student.id = doc.id
        this.$router.push({
        name: "TodorhoiloltDetail2",
        params: { itemRefPath: item.ref.path, student: student },
      });
      })
      
    },
     
    _read() {
      fb.db
        .collection(this._getPath())
        .where("forWhom","==", this.userProfile.role=='student'?"Оюутан":"Багш")
        .orderBy("createdAt", "desc")
        .onSnapshot((querySnapshot) => {
          this.items = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.items.push(item);
          });
        });
    },
    _getPath() {
      return fb.yyschool + "/" + this.item.fbpath;
    },
  },
};
</script>
